import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { initializeAuth } from "../redux/action/actions";
import Header from "./Header";
import Footer from "./Footer";
import ScrollTop from "../components/ScrollTop";
import SessionExpiryWarning from "../components/SessionExpiryWarning/SessionExpiryWarning";
import ToastManager from "../components/ToastManager/ToastManager";

const MainLayout = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        // Initialize authentication state from localStorage
        dispatch(initializeAuth());
    }, [dispatch]);

    return (
        <div className="min-h-screen min-w-screen flex flex-col">
            <ScrollTop />
            <SessionExpiryWarning />
            <ToastManager />
            <Header />
            <main className="flex-grow">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
};

export default MainLayout;
